import React, { useEffect, useState } from 'react';
import { Box, Fade, useMediaQuery, useTheme } from '@mui/material';

export default function ScrollTopButton() {
  const [visible, setVisible] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 200);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Fade in={visible}>
      <Box
        onClick={handleClick}
        sx={{
          position: 'fixed',
          bottom: isMobile ? 20 : 30,
          right: isMobile ? 20 : 30,
          width: isMobile ? 36 : 44,
          height: isMobile ? 36 : 44,
          cursor: 'pointer',
          zIndex: 9999,
        }}
      >
        <img
          src="https://res.cloudinary.com/dhoyyqszi/image/upload/v1748387504/ebm/scrollToTop_pnjeu2.svg"
          alt="Ir arriba"
          style={{ width: '100%', height: '100%' }}
        />
      </Box>
    </Fade>
  );
}